module.exports = __webpack_public_path__ + "static/media/MASS.74483867.png";